
document.addEventListener('DOMContentLoaded', function () {

  function applyAuctionPriceToCard(card) {      
      if (card.dataset.hasAuction !== "true") return;

      const productId = card.dataset.productId;
      let priceEl = card.querySelector('.price__regular .price-item--regular');
      if (!priceEl) {
        priceEl = card.querySelector('.card-information .price');
      }

      if (!productId || !priceEl) return;      

      fetch(`https://auctionhelper.apps.aico.swiss/api/get/auction_price/${productId}`)
        .then(res => res.json())
        .then(data => {
               
          if (!data) return;
          const auction = data.auction;
          const highest = Number(auction.highest_bid);
          const starting = Number(auction.starting_price);          
          if (highest > starting) {
            const highest_price = highest.toFixed(2);
            priceEl.innerHTML = `${Currency} ${highest_price}`;
          }          
        })
        .catch(err => {
          console.log("Auction API error for product:", productId, err);
        });
        
  }

  function applyAuctionPriceToExistingCards() {    
    const existingCards = document.querySelectorAll('#product-grid .grid__item');

    existingCards.forEach(card => {
      applyAuctionPriceToCard(card);
    });
  }

  function initInfiniteScroll() {
    const grid = document.getElementById('product-grid');
    const trigger = document.getElementById('load-more-trigger');
    const collectionHandle = window.CollectionHandle;
    const productsPerPage = 10;
    const requestType = window.requestType;

    let currentPage = requestType == "search" ? 2 : 1;
    let leftovers = [];
    let loading = false;    

    if (!grid || !trigger) return;

    const scrollobserver = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        console.log('[OBSERVE] Trigger in view, loading next batch...');
        loadNextBatch();
      }
    }, { rootMargin: '0px 0px 200px 0px' }); // Trigger 500px before the viewport

    scrollobserver.observe(trigger);

    function buildAjaxURL(page) {
      const params = new URLSearchParams(window.location.search);
      params.set('page', page);
      params.set('view', 'ajax');
      if (requestType == "search") {
        endPoint = `/search?${params.toString()}`;
      } else if (requestType == "collection") {
        endPoint = `/collections/${collectionHandle}?${params.toString()}`;
      }
      return endPoint;
    }

    function loadNextBatch() {
      if (loading) return;
      loading = true;
      trigger.classList.add('loading');

      if (leftovers.length >= productsPerPage) {
        const toRender = leftovers.slice(0, productsPerPage);
        leftovers = leftovers.slice(productsPerPage);
        console.log(`[LEFTOVERS] Rendering ${toRender.length}, leftover after: ${leftovers.length}`);
        renderProducts(toRender);
        loading = false;
        trigger.classList.remove('loading');
        return;
      }

      if (leftovers.length > 0) {
        console.log(`[LEFTOVERS] Have only ${leftovers.length}, fetching next page to complete batch...`);
      }

      const url = buildAjaxURL(currentPage);
      console.log(`[FETCH] Getting page ${currentPage} → ${url}`);

      fetch(url)
        .then(res => res.text())
        .then(html => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = html;
          const fetchedItems = Array.from(tempDiv.querySelectorAll('.grid__item'));
          console.log(`[FETCHED] ${fetchedItems.length} products fetched from page ${currentPage}`);

          if (fetchedItems.length === 0) {
            if (leftovers.length > 0) {
              console.log('[END] No more products to fetch. Rendering final leftovers.');
              renderProducts(leftovers);
              leftovers = [];
            } else {
              console.log('[END] No more products and no leftovers. Removing trigger.');
            }
            scrollobserver.unobserve(trigger);
            trigger.remove();
            return;
          }

          const renderedIDs = Array.from(document.querySelectorAll('.grid__item[data-product-id]'))
            .map(el => el.getAttribute('data-product-id'));

          const uniqueProducts = fetchedItems.filter(item => {
            const id = item.getAttribute('data-product-id');
            return id && !renderedIDs.includes(id);
          });          

          let combined = leftovers.concat(uniqueProducts);
          const toRender = combined.slice(0, productsPerPage);
          leftovers = combined.slice(productsPerPage);

          console.log(`[RENDER] Rendering ${toRender.length} items (combined leftovers + new)`);
          renderProducts(toRender);
          currentPage++;
          loading = false;
          trigger.classList.remove('loading');
        })
        .catch(err => {
          console.error('[ERROR]', err);
          loading = false;
          trigger.classList.remove('loading');
        });
    }

    function extractAicoPriceFromCard(card) {
        // Ensure aico object and array exist
        if (!window.aico) window.aico = {};
        if (!aico.aico_price_list_products) aico.aico_price_list_products = [];
        // Find the span tag with id="aico-price-list" within the card
        const spanTag = card.querySelector('#aico-price-list');    
          
        if (!spanTag) {
            console.error('Span tag with id="aico-price-list" not found in the provided card.');
            return;
        }
    
        // Get the JSON data from the data-aico_price_object attribute
        const jsonData = spanTag.getAttribute('data-aico_price_object');
        if (!jsonData) {
            console.error('data-aico_price_object attribute not found or empty in the span tag.');
            return;
        }
    
        try {
          if (
                window.aico_percentage_discount &&
                window.aico_percentage_discount != 0
              ) {
            // Parse the JSON data
            const aico_price_object = JSON.parse(jsonData);
    
            // Ensure the handle property exists
            const productHandle = aico_price_object.handle;
            if (!productHandle) {
                console.error('Product handle not found in aico_price_object.');
                return;
            }
            // aico_price_object.aico_product_collections = 'all';
            // Push the price object into aico.aico_price_list_products with the product handle
            aico.aico_price_list_products.push({ [productHandle]: aico_price_object });
            
            console.log(`Successfully added price object for product: ${productHandle}`, aico_price_object);
            

                  countAicoProductPrice();

              }
        } catch (error) {
            console.error('Error parsing data-aico_price_object JSON in card:', error);
        }
    }

    function renderProducts(cards) {
      console.log(`[renderProducts] Appending ${cards.length} product(s) to grid`);
      const fragment = document.createDocumentFragment();
      cards.forEach(card => {
        extractAicoPriceFromCard(card);
        applyAuctionPriceToCard(card);
        fragment.appendChild(card);
      });


      grid.appendChild(fragment);
      aicoInitWishlistIcons();
      if (
        window.aico_percentage_discount &&
        window.aico_percentage_discount != 0
      ) {
          countAicoProductPrice();
      }

      if(is_membership){
        $('.quick-add__submit').addClass('cart_has_membership');
        $('.product-form__submit').addClass('cart_has_membership');
        $('#modal-product-options').find('.product-form__submit').removeClass('cart_has_membership');
      }
    }

    applyAuctionPriceToExistingCards();
  }

  initInfiniteScroll();

  document.addEventListener('collection:updated', () => {
    initInfiniteScroll();
    console.log('[RESET] Detected filter/sort change, resetting infinite scroll...');
  });
});